import * as types from './updateSystemActionTypes';
import { getSpecificEdition } from './../Editions/editionsActions';
import { getArticlesByThematic } from './../Thematics/thematicsActions';
import { getArticleContent } from './../Article/articleActions';
import { setupInit } from './../SetupLoader/setupLoaderActions';
import { resetStore, getProductByPage } from './../StorePage/StoreActions';

export const changeLastDataUpdateDate = (date) => {
  return {
    type: types.CHANGE_DATE,
    date
  }
}

export const changeLastProductUpdateDate = (date) => {
  return {
    type: types.CHANGE_PRODUCT_DATE,
    date
  }
}

export const alreadyInit = () => {
  return {
    type: types.ALREADY_INIT
  }
}

export const processDate = (date) => {
  return (dispatch, getState) => {
    if(getState().updateSystem.lastDataUpdateDate < date  && getState().auth.isUserSignedIn) //user is sign in
    {
      //Editions update
      dispatch(getSpecificEdition(getState().editions.current.publication_date));

      //Thematics update
      if(getState().thematics.currentThematic !== "")
      {
        dispatch(getArticlesByThematic(getState().thematics.currentThematic, false));
      }

      //Article update
      if(typeof getState().article.currentArticle.id !== "undefined")
      {
        dispatch(getArticleContent(getState().article.currentArticle.id, false));
      }
      
      //Update store date
      dispatch(changeLastDataUpdateDate(date));
    }
    else if (getState().updateSystem.lastDataUpdateDate < date) //user is not sign in
    {
      //reload setup loader
      //already initialised so we reload the setup loader (this is check to avoid to call the setupLoader twice on first loading)
      if( getState().updateSystem.lastDataUpdateDate !== 0 ) 
        dispatch(setupInit());

      //Update store date
      dispatch(changeLastDataUpdateDate(date));
    }
    else {
      dispatch(alreadyInit());
    }
  }
}

export const processProductDate = (date) => {
  return (dispatch, getState) => {

    if (getState().updateSystem.lastProductUpdateDate < date)
    {
      //we reset the store
      dispatch(resetStore());

      //we load all the store pages
      dispatch(getProductByPage(1)); //We only have 1 page

      //Update store date
      dispatch(changeLastProductUpdateDate(date));
    }
    else {
      dispatch(alreadyInit());
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/UpdateSystem/updateSystemActions.js